// TODO: комментарии, рефакторинг

export function deleteDuplicateInArray(arr: any[], [...properties]: string[]) {
  const copiedArr = [...arr]

  for (let i = 0; i < copiedArr.length; ++i) {
    for (let j = i + 1; j < copiedArr.length; ++j) {
      const propertiesLength = properties.length

      let matches = 0

      properties.forEach((property) => {
        if (copiedArr[i][property] === copiedArr[j][property]) {
          matches++
        }
      })

      if (propertiesLength === matches) {
        copiedArr.splice(j--, 1)
      }
    }
  }

  return copiedArr
}
// TODO: задокументировать
